<template>
  <div :class="'badge ' + (className ? className : 'primary')">
    <span v-if="!icon && dot" :class="'badge__dot ' + (className ? className : 'primary')"></span>
    <FontAwesomeIcon v-else :icon="'fa-light fa-' + icon" />
    {{ text ?? "" }}
  </div>
</template>

<script>
export default {
  name: "BadgeComponent",
  props: {
    icon: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: false,
      default: "",
    },
    dot: {
      type: Boolean,
      required: false,
      default: true,
    },
    className: {
      type: String,
      required: false,
      default: "",
    },
  },
  emits: ["buttonClick"],
  methods: {
    click() {
      this.$emit("buttonClick");
    },
  },
};
</script>

<style lang="scss" scoped>
.badge {
  cursor: default;
  width: fit-content;
  border: 1px solid $m-color_3;
  background-color: rgba(224, 230, 237, 0.2);
  border-radius: 6px;
  padding: 5px 10px;
  font-weight: 600;

  @include dark-theme {
    color: $white !important;
  }

  &__dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 10px;
    background-color: $m-color_3;
    margin-right: 5px;
    @include dark-theme {
      background-color: $white !important;
    }
  }

  &.success {
    border-color: $green;
    background-color: rgba(106, 199, 164, 0.2);
    color: $green;

    .badge__dot {
      background-color: $green;
    }
  }

  &.warning {
    border-color: $orange;
    background-color: rgba(248, 160, 7, 0.2);
    color: $orange;

    .badge__dot {
      background-color: $orange;
    }
  }

  &.danger {
    border-color: $red;
    background-color: rgba(218, 81, 100, 0.2);
    color: $red;

    .badge__dot {
      background-color: $red;
    }
  }

  &.primary {
    border-color: $primary;
    background-color: rgba(13, 110, 253, 0.2);
    color: $primary;

    .badge__dot {
      background-color: $primary;
    }
  }

  &.dark-grey {
    border-color: $darker-grey;
    background-color: rgba(29, 29, 29, 0.2);
    color: $darker-grey;

    .badge__dot {
      background-color: $darker-grey;
    }
  }
}
</style>
